import { useEffect } from 'react';

export function usePageTitle(title: string, enabled = true) {
  useEffect(() => {
    if (!enabled) return;
    document.title = title ? `${title} — ATLAS` : 'ATLAS';
    return () => { document.title = 'ATLAS'; };
  }, [title, enabled]);
}
